import axios from 'axios'

const http = {}
const methods = ['get', 'post']

const search = location.hash
const token = localStorage.getItem("token") || ''
methods.forEach(v => {
    http[v] = (url, data, baseUrl, headers, params) => {
        const axiosConfig = {
            method: v,
            url,
            baseURL: baseUrl,
            headers: {
                ...headers,
                'Content-Type': 'application/json; charset=utf-8',
                'token': token
            },
            withCredentials: false
        };
        const instance = axios.create();

        // request interceptor
        instance.interceptors.request.use(
            cfg => ({
                ...cfg,
                params: {
                    ...cfg.params,
                }
            }),
            error => Promise.reject(error)
        );

        // response interceptor
        instance.interceptors.response.use(
            response => {
                // 正常返回, 并且状态码为 2xx
                return response.data;
            },
            error => {
                // 状态码非 2xx, 请求中出现错误, 主动取消, 请求超时
                return Promise.reject(error);
            }
        );

        if (v === 'get') {
            axiosConfig.params = data;
        } else if (v === 'post') {
            if (params) {
                const formData = new FormData();
                for (const key of Object.keys(params)) {
                    formData.append(key, params[key]);
                }
                axiosConfig.data = formData;
            } else if (data) {
                axiosConfig.data = data;
            }
        }

        axiosConfig.startTime = new Date();

        return instance
            .request(axiosConfig)
            .then(res => res)
            .catch(err => err);
    };
});

export default http;
